import { Comment } from "api/types";
import {
	Grid,
	styled,
	Avatar,
	ListItemText,
	ListItemAvatar,
	ListItem,
	List,
	Typography,
} from "@mui/material";

const PREFIX = "CommentList";

const classes = {
	root: `${PREFIX}-root`,
	avatar: `${PREFIX}-avatar`,
};

const Root = styled(Grid)(() => ({
	borderRadius: 5,
}));

interface CommentListProps {
	commentList: Comment[];
}

export const CommentList = ({ commentList }: CommentListProps): JSX.Element => {
	const getInitials = (name: string): string => {
		const token = name.split(" ", 2);
		if (token.length > 1) {
			const t1 = token[0] ? token[0].charAt(0).toUpperCase() : "";
			const t2 = token[1] ? token[1].charAt(0).toUpperCase() : "";
			return t1 + t2;
		}
		return name.charAt(0).toLowerCase();
	};
	return (
		<Root className={classes.root}>
			<List sx={{ width: "100%", bgcolor: "background.paper" }}>
				{commentList === null || commentList.length === 0 ? (
					<Typography variant="h4">No comments from teacher</Typography>
				) : (
					commentList.slice(0, 5).map((item) => (
						<ListItem key={item.commentId}>
							<ListItemAvatar>
								<Avatar>{getInitials(item.commentFrom)}</Avatar>
							</ListItemAvatar>
							<Grid container flexDirection="row">
								<Grid item xs={2}>
									{item.commentTo !== "" ? (
										<ListItemText
											primary={`From: ${item.commentFrom} To: ${item.commentTo}`}
											secondary={item.date}
										/>
									) : (
										<ListItemText
											primary={`${item.commentFrom}`}
											secondary={item.date}
										/>
									)}
								</Grid>
								<Grid item xs>
									<ListItemText primary={item.comment} />
								</Grid>
							</Grid>
						</ListItem>
					))
				)}
			</List>
		</Root>
	);
};
